if(typeof BSS_B2B != 'undefined'){
  setTimeout(()=> {
 let elm_selector = window.location.pathname === '/cart' ? 'form.cart__contents' : '.cart-drawer-container';
let time = window.location.pathname === '/cart' ? 50 : 500;
const elm = document.querySelector(elm_selector);
    if(elm){
      const observer = new MutationObserver((MutationList)=>{
        for(let item of MutationList){
          if((item.target.id.includes('main-cart-items') && !item.target.className.includes('cart__items--disabled')) || item.target.className.includes('cart-drawer-container')){
            BSS_B2B.cart.fixer(JSON.parse($('#bss-b2b-store-data').html()), false, false);
                 setTimeout(() => {
                   const btn_submit = document.querySelector('.cart__checkout-button.button, .button-container .button[name="checkout"]');
              if(btn_submit){
                btn_submit.style = 'pointer-events: none';
              }
                 }, time)
                  document.addEventListener("bss_b2b_cart_fixer_done", () => {
             const btn_submit = document.querySelector('.cart__checkout-button.button, .button-container .button[name="checkout"]');
              if(btn_submit){
                btn_submit.style = 'pointer-events:auto';
              }
            })
               setTimeout(()=>{
                   const btn_submit = document.querySelector('.cart__checkout-button.button, .button-container .button[name="checkout"]');
              if(btn_submit){
                btn_submit.style = 'pointer-events:auto';
              }
               }, 5000)   
              }
          
          }
        })
              observer.observe(elm, {attributes: true, childList: true, subtree: true})
    }
  }, 500)
}